
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Search,
  MessageCircle,
  ClipboardCheck,
  ArrowRight,
  ShieldCheck,
  Wrench,
  Truck
} from "lucide-react";
import UserHeader from "../components/UserHeader";
import InfoLayout from "./InfoLayout";

export default function About() {
  const [searchParams] = useSearchParams();
  const isAppView = searchParams.get("app") === "1";

  return (
    <>
      {!isAppView && <UserHeader />}

      <InfoLayout
        label="About Us"
        title="Finding car parts, made simpler."
        subtitle="FindAutoParts helps people and workshops connect with part suppliers, request quotes and keep conversations organised in one place."
      >
        <section className="fi-grid" aria-label="Why use FindAutoParts">
          <article className="fi-card">
            <Search size={27} />
            <h2>Find the right part</h2>
            <p>
              Search by vehicle information or browse common part
              categories to start your request.
            </p>
          </article>

          <article className="fi-card">
            <MessageCircle size={27} />
            <h2>Compare your options</h2>
            <p>
              Receive supplier quotations and ask questions before
              deciding what suits your vehicle.
            </p>
          </article>

          <article className="fi-card">
            <ClipboardCheck size={27} />
            <h2>Keep track easily</h2>
            <p>
              View your quote history, notifications and supplier
              conversations in your account.
            </p>
          </article>
        </section>

        <section className="fi-section fi-split">
          <div className="fi-card fi-prose">
            <h2 className="fi-section-title">
              Built around your workflow
            </h2>
            <p>
              Finding a replacement engine, transmission, body panel
              or smaller component can involve several calls and
              messages. FindAutoParts brings the key steps together
              so your request and responses are easier to follow.
            </p>
            <p>
              Whether you're organising repairs for your own car or
              sourcing parts for workshop jobs, our goal is a clear
              and straightforward experience.
            </p>
            <p className="fi-muted">
              Part availability, suitability, pricing, delivery
              arrangements and any warranty terms should be
              confirmed with the relevant supplier before purchase.
            </p>
          </div>

          <div className="fi-panel-dark">
            <Wrench size={34} color="#fb4056" />
            <h2>Have a part in mind?</h2>
            <p>
              Start with your vehicle details, then explore
              available request options.
            </p>
            <div className="fi-buttons">
              <Link
                className="fi-btn fi-btn-primary"
                to={isAppView ? "/search?app=1" : "/search"}
              >
                Find parts <ArrowRight size={17} />
              </Link>
            </div>
          </div>
        </section>

        <section className="fi-section">
          <h2 className="fi-section-title">What matters to us</h2>

          <div className="fi-grid">
            <div className="fi-card">
              <ShieldCheck size={26} />
              <h3>Clear information</h3>
              <p>
                Keep part details, quotes and important messages
                easy to understand.
              </p>
            </div>

            <div className="fi-card">
              <Truck size={26} />
              <h3>Flexible sourcing</h3>
              <p>
                Help customers explore replacement options for
                a wide range of vehicles.
              </p>
            </div>

            <div className="fi-card">
              <MessageCircle size={26} />
              <h3>Helpful communication</h3>
              <p>
                Give customers a place to discuss fitment and
                ask questions.
              </p>
            </div>
          </div>
        </section>
      </InfoLayout>
    </>
  );
}
